import { css } from '@emotion/react';
import { gray7 } from 'styles/global_defaults/colors';
import { TIME_SLOT_COLUMN_HEIGHT } from './availability-calendar-grid';

const styles = css`
  height: 100%;
  min-height: ${TIME_SLOT_COLUMN_HEIGHT}px;
  background-color: ${gray7};
`;

const EmptyTimeSlot = () => <div css={styles} className='empty-slots' />;

export default EmptyTimeSlot;
